import React, { useEffect, useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Button } from '@nextui-org/react';
import { LogIn, UserPlus } from 'lucide-react';
import auth from '../Auth'; // Ensure this path is correct
const LoginPage = () => {
  const errorMessage = 'There was an error logging in. Please try again.';
  const [error, setError] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [exchangeAttempted, setExchangeAttempted] = useState(false);
  const cognitoUrl = auth.getCognitoUrl();
  const cloudUrl = '/prompts';

  useEffect(() => {
    const getCodeFromURL = () => {
      const queryParams = new URLSearchParams(location.search);
      return queryParams.get('code');
    };

    const handleAuthentication = async () => {
      const code = getCodeFromURL();

      if (code && !exchangeAttempted) {
        setExchangeAttempted(true);
        try {
          await auth.exchangeCodeForToken(code);
          navigate(cloudUrl)
        } catch (error) {
          setError(true);
          console.error(error);
          navigate('/login', { replace: true });
        }
      }
    };

    handleAuthentication();
  }, [location, navigate, cloudUrl, exchangeAttempted]); // Dependencies are unlikely to change, but are included for correctness

  return (
    <div className='flex flex-col min-h-screen bg-white'>
      <main className='flex flex-col items-center justify-center flex-grow text-center p-6'>
        <h1 className='text-4xl font-semibold text-gray-900'>Authentication Required</h1>
        {error && <div className='text-red-500 mt-2'>{errorMessage}</div>}
        <p className='text-lg text-gray-700 mt-3'>Please log in to access this page.</p>
        <div className='space-x-4 mt-5'>
          <Link to={cognitoUrl}>
            <Button
              size='small'
              auto
              style={{ backgroundColor: 'white', border: '1px solid black' }}
              onPress={() => {
                window.location.href = cognitoUrl;
              }}
            >
              <LogIn className='h-5 w-5' />
              Log in
            </Button>
          </Link>
          <Link to={cognitoUrl}>
            <Button
              size='small'
              auto
              style={{ backgroundColor: 'black', color: 'white' }}
              onPress={() => {
                window.location.href = cognitoUrl;
              }}
            >
              <UserPlus className='h-5 w-5' />
              Sign up
            </Button>
          </Link>
        </div>
      </main>
    </div>
  );
};

export default LoginPage;
